<div class="relative" data-aos="fade-up" [attr.data-aos-delay]="step.id * 150">

  @if (showConnector) {
  <div
    class="hidden lg:block absolute top-16 start-full w-full h-[2px] bg-gradient-to-r rtl:bg-gradient-to-l from-border-subtle to-transparent sticky-connector">
  </div>
  }

  <div
    class="relative surface-card p-6 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 h-full border hover:border-primary/50">

    <div [ngClass]="step.gradientClasses"
      class="absolute -top-5 -start-4 w-10 h-10 rounded-xl flex items-center justify-center shadow-md text-white font-bold text-sm select-none">
      <span>{{ step.id.toString().padStart(2, '0') }}</span>
    </div>

    <div [ngClass]="step.bgLightClass" class="w-14 h-14 rounded-xl flex items-center justify-center mb-5 mt-2">
      <div [ngClass]="step.gradientClasses"
        class="w-10 h-10 rounded-lg flex items-center justify-center transform transition-transform duration-300 hover:scale-110 shadow-sm">
        <i [class]="step.icon" class="text-lg text-white"></i>
      </div>
    </div>

    <h3 class="text-text-primary mb-2 text-base font-bold tracking-tight">{{ step.title }}</h3>
    <p class="text-text-secondary text-sm leading-relaxed">{{ step.description }}</p>
  </div>
</div>